<div class="source-panel-container">
  <div *ngIf="pageName === 'mex'">
    <div class="source-placement-container">
      <div class="align-content">
        <b><p>Source Placement</p></b>
      </div>

      <nz-radio-group
        [nzSize]="'small'"
        [(ngModel)]="sourcePlacement"
        (ngModelChange)="handleSourceType($event)"
      >
        <label nz-radio-button nzValue="row"><b>Rows</b></label>
        <label nz-radio-button nzValue="column"><b>Columns</b></label>
      </nz-radio-group>
    </div>

    <div class="calculated-source-container">
      <div class="align-content">
        <b><p>Show Calculated Sources</p></b>
      </div>
      <div *ngIf="isConsensusPlusUser && cut !== 'SAR'">
        <span
          nz-popover
          nzPopoverOverlayClassName="panel-popover"
          nzPopoverPlacement="left"
          nzPopoverTrigger="hover"
          [nzPopoverContent]="consensusPlusPopoverTemplate"
        >
          <label
            nz-checkbox
            class="checkbox-extra-sm"
            [(ngModel)]="consensusPlusCheck"
            (ngModelChange)="consensusPlusChecked($event)"
            [ngClass]="
              focusedForecastSource === 'Consensus+' ||
              focusedActualSource === 'Consensus+'
                ? 'disable-checkbox'
                : ''
            "
          >
            <span
              >Consensus
              <va-icon
                size="small"
                style="color: #f2883d; vertical-align: middle"
                name="plus"
                class="icon"
              ></va-icon
            ></span> </label></span
        ><br />
      </div>
      <div>
        <span>
          <label
            class="checkbox-extra-sm"
            nz-checkbox
            [(ngModel)]="consensusCheck"
            (ngModelChange)="consensusChecked($event)"
            [ngClass]="
              focusedForecastSource === 'Consensus' ||
              focusedActualSource === 'Consensus'
                ? 'disable-checkbox'
                : ''
            "
          >
            <span>Consensus</span>
          </label></span
        ><br />
        <span
          nz-popover
          nzPopoverOverlayClassName="panel-popover"
          nzPopoverPlacement="left"
          nzPopoverTrigger="hover"
          nzPopoverContent="Select and deselect brokers to include in consensus"
        >
          <label
            nz-checkbox
            class="checkbox-extra-sm"
            [(ngModel)]="customConsensusCheck"
            (ngModelChange)="ccChecked($event)"
            [ngClass]="
              ['Custom Consensus', 'Custom'].includes(focusedForecastSource) ||
              ['Custom Consensus', 'Custom'].includes(focusedActualSource)
                ? 'disable-checkbox'
                : ''
            "
          >
            <span>Custom Consensus</span>&nbsp;<img
              [src]="assets + '/custom_consensus.png'"
            /> </label
        ></span>
        <button
          nz-button
          *ngIf="customConsensusCheck"
          (click)="showCustomConsensus()"
        >
          Edit
        </button>
      </div>
    </div>

    <nz-divider></nz-divider>

    <div class="historical-source-container">
      <div class="align-content">
        <b><p>Historicals</p></b>
      </div>
      <div>
        <span>
          <label
            nz-checkbox
            class="checkbox-extra-sm"
            [(ngModel)]="filingsCheck"
            (ngModelChange)="filingsChecked($event)"
            [ngClass]="
              focusedActualSource === 'Filings' ? 'disable-checkbox' : ''
            "
          >
            <span>Filings (last date {{ lastFilingsDate }})</span>
          </label></span
        ><br />
        <span>
          <label
            nz-checkbox
            class="checkbox-extra-sm"
            [(ngModel)]="vaActualsCheck"
            (ngModelChange)="vaActualsChecked($event)"
            [ngClass]="
              focusedActualSource === 'VA Actuals' ? 'disable-checkbox' : ''
            "
          >
            <span>VA Actuals</span>
          </label></span
        >
        <va-icon
          size="small"
          name="info-circle"
          class="info-icon-sm"
          nz-popover
          nzPopoverOverlayClassName="panel-popover"
          nzPopoverPlacement="left"
          nzPopoverContent="VA Actuals combines company reported numbers with the intelligence of sell-side community to provide actuals that are likely to be most comparable with their forecasts."
        >
        </va-icon>
      </div>
      <div class="historical-focus-list">
        <label><b>Focus&nbsp;</b></label>
        <select
          *ngIf="focusedActualSource !== null"
          [(ngModel)]="focusedActualSource"
          (ngModelChange)="onUpdateFocus($event, 'actual', {})"
          class="select-picker"
        >
          <option *ngFor="let name of historicalFocusList" [ngValue]="name">
            {{ name === "Custom" ? "Custom Consensus" : name }}
          </option>
        </select>
      </div>
    </div>

    <nz-divider></nz-divider>
  </div>

  <div class="source-list-container">
    <div>
      <div class="align-content">
        <b><p class="bottom-margin">Show Brokers</p></b>
        <span (click)="onClearClick()" *ngIf="pageName !== 'mex'">Clear</span>
      </div>
      <p class="grey-text bottom-margin">Show and Sort Order in View</p>
      <span class="align-right"
        ><label>Show Only Current</label
        ><nz-switch
          nzSize="small"
          [(ngModel)]="showOnlyCurrent"
          (ngModelChange)="onShowCurrentSwitch($event, {})"
        ></nz-switch
      ></span>
    </div>

    <ng-container *ngTemplateOutlet="brokerGridTemplate"></ng-container>

    <div>
      <b><p class="mb-8">Set Focus: Forecast</p></b>
      <p class="grey-text">Source that separates periods</p>
      <select
        [(ngModel)]="focusedForecastSource"
        (ngModelChange)="onUpdateFocus($event, 'forecast', {})"
        class="select-picker"
      >
        <option *ngFor="let name of forecastFocusList" [ngValue]="name">
          {{ name === "Custom" ? "Custom Consensus" : name }}
        </option>
      </select>
    </div>

    <div class="action-buttons">
      <button
        [disabled]="disabled"
        nz-button
        nzType="default"
        nzSize="small"
        [ngClass]="!disabled ? 'cancelBtn' : ''"
        (click)="onCancelClick()"
      >
        Cancel
      </button>

      <button
        [disabled]="disabled"
        nz-button
        nzType="primary"
        nzSize="small"
        (click)="onApplyClick($event)"
      >
        Apply
      </button>
    </div>
  </div>

  <ng-template #brokerGridTemplate>
    <div>
      <nz-table
        #sortTable
        [nzData]="brokersList"
        [nzShowPagination]="false"
        [nzScroll]="{ y: '230px' }"
      >
        <thead>
          <tr>
            <th
              class="checkbox-extra-sm"
              [nzShowCheckbox]="true"
              [(nzChecked)]="checkAll"
              [nzIndeterminate]="indeterminate"
              (nzCheckedChange)="onCheckAll($event)"
              nzWidth="30px"
            ></th>
            <th
              (nzSortOrderChange)="sort($event, 'name')"
              [nzSortFn]="true"
              nzWidth="90px"
            >
              Brokers
            </th>
            <th
              (nzSortOrderChange)="sort($event, 'modeldatetime')"
              [nzSortFn]="true"
              nzWidth="80px"
            >
              Date
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let row of brokersList"
            [ngClass]="row.focus ? 'row-disabled' : ''"
          >
            <td
              class="checkbox-extra-sm"
              [nzShowCheckbox]="true"
              [nzChecked]="row.selected"
              (nzCheckedChange)="onRowChecked(row.sourceid, $event)"
              [ngClass]="row.focus ? 'disable-checkbox' : ''"
            ></td>
            <!-- <td *ngIf="row.name.length < 10">
              {{ row.name | textEllipsis: 10
              }}<span *ngIf="row.excluded && !row.selected_cc">
                <img
                  [src]="assets + '/icon-excluded.png'"
                  class="excluded-icon"
                />
              </span>
              <span *ngIf="row.excluded && row.selected_cc">
                <img
                  [src]="assets + '/icon-excluded.png'"
                  class="excluded-icon"
                />
                <img
                  [src]="assets + '/custom_consensus.png'"
                  class="excluded-icon"
                />
              </span>
              <span *ngIf="!row.excluded && row.selected_cc">
                <img
                  [src]="assets + '/custom_consensus.png'"
                  class="excluded-icon"
                />
              </span>
            </td>
            <td
              *ngIf="row.name.length > 9"
              nz-tooltip
              nzTooltipTitle="{{ row.name }}"
              nzTooltipPlacement="bottomLeft"
              nzTooltipMouseEnterDelay="10"
              [nzTooltipOverlayStyle]="{
                fontSize: '11px',
                padding: '0px',
                background: '#999'
              }"
            >
              {{ row.name | textEllipsis: 6
              }}<span *ngIf="row.excluded && !row.selected_cc">
                <img
                  [src]="assets + '/icon-excluded.png'"
                  class="excluded-icon"
                />
              </span>
              <span *ngIf="row.excluded && row.selected_cc">
                <img
                  [src]="assets + '/icon-excluded.png'"
                  class="excluded-icon"
                />
                <img
                  [src]="assets + '/custom_consensus.png'"
                  class="excluded-icon"
                />
              </span>
              <span *ngIf="!row.excluded && row.selected_cc">
                <img
                  [src]="assets + '/custom_consensus.png'"
                  class="excluded-icon"
                />
              </span>
            </td> -->
            <td style="max-width: 100px">
              <app-source-name-table-display
                [brokerItem]="row"
                [showCurrentViewInfo]="false"
                [currentState]="row.selected"
                [ccState]="ccState"
                (nameClicked)="onRowChecked($event.id, $event.selected)"
              ></app-source-name-table-display>
            </td>
            <td>{{ row.modeldate }}</td>
          </tr>
        </tbody>
      </nz-table>
      <span
        *ngIf="exclNonEntitled.length > 0 || nonEntitled.length > 0"
        nz-tooltip
        nzTooltipTitle="{{ unentitledAllBrokerListForToolTip }}"
        nzTooltipPlacement="bottomLeft"
        [nzTooltipOverlayStyle]="{
          fontSize: '11px',
          padding: '0px',
          background: '#999'
        }"
        >Unentitled&nbsp;<va-icon
          size="small"
          name="info-circle"
          class="info-icon-sm"
        ></va-icon
      ></span>
    </div>
  </ng-template>
</div>

<ng-template #consensusPlusPopoverTemplate>
  <span>Consensus&nbsp;</span
  ><va-icon
    size="small"
    style="color: #f2883d; vertical-align: middle"
    name="plus"
    class="icon"
  ></va-icon
  ><span
    >&nbsp;includes additional brokers not available in Visible Alpha’s standard
    consensus</span
  >
</ng-template>
